import  { CARGAR_CHEQUES } from './actionTypes';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';
import global_axios from '../../funciones_globales/interaccionapi';

export const cargar_Cheques = (estadoCheque, fechaVctoDesde=null, fechaVctoHasta=null, codCliente='') => {
	
	let url = `/chequescliente?estado=${estadoCheque}`;
	if(fechaVctoDesde!==null){
		url += `&fechaVctoDesde=${fechaVctoDesde}`;
	}
	if(fechaVctoHasta!==null){
		url += `&fechaVctoHasta=${fechaVctoHasta}`;
	}	
	if(codCliente!==''){
		url += `&codCliente=${codCliente}`;
	}

	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let cheques = response.data;		
			dispatch({
				type: CARGAR_CHEQUES,
				data: cheques
			})
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			})
		})
		.catch((error)=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});						
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar cheques', mensaje: msgError}
			});
		});
	}
}

export const cargar_ChequesSinAplicar = (fechaCobroDesde, fechaCobroHasta, fechaVctoHasta) => {
	return (dispatch) => {
		let url = "/chequescliente?tipo=ChqSinAplicar&fechaCobroDesde=" + fechaCobroDesde + "&fechaCobroHasta=" + fechaCobroHasta + "&fechaVencHasta=" + fechaVctoHasta;
		let config_request = {
			method: 'GET',
			url
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let chequesSinAplicar = response.data;
			dispatch({
				type: CARGAR_CHEQUES,
				data: chequesSinAplicar
			})
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			})
		})
		.catch((error)=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});						
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar cheques', mensaje: msgError}
			});
		});
	}
}

export const inicializar_Cheques = () => {
	return { 	type: CARGAR_CHEQUES,
				data: []
		}
}